import { Star, Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import Link from 'next/link';
import Image from 'next/image';

interface PropertyServiceFormData {
  id?: number | string;
  name: string;
  slug: string;
  description?: string;
  media?: {
    images: string[];
    gallery: string[];
    videos: string[];
    map: string;
  };
  sort_order?: number;
  is_active?: boolean;
  category?: string;
}

interface ServiceCardProps {
  service: PropertyServiceFormData;
  isHovered: boolean;
  onHover: () => void;
  onLeave: () => void;
}

export default function ServiceCard({ service, isHovered, onHover, onLeave }: ServiceCardProps) {
  // Combine main image with gallery images
  const allImages = [
    ...(service.media?.images || []),
    ...(service.media?.gallery || []),
  ];

  return (
    <div
      className={`bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer ${isHovered ? 'ring-2 ring-secondary' : ''
        }`}
      onMouseEnter={onHover}
      onMouseLeave={onLeave}
    >
      {/* <div className="relative h-56 overflow-hidden">
        {allImages.length > 0 ? (
          <Carousel className="w-full h-full">
            <CarouselContent>
              {allImages.map((imageUrl: string, index: number) => (
                <CarouselItem key={index}>
                  <Image
                    height={240}
                    width={320}
                    src={imageUrl}
                    alt={`${service.name} - Image ${index + 1}`}
                    className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                  />
                </CarouselItem>
              ))}
            </CarouselContent>
            {allImages.length > 1 && (
              <>
                <CarouselPrevious className="left-2 bg-white/80 hover:bg-white shadow-lg" />
                <CarouselNext className="right-2 bg-white/80 hover:bg-white shadow-lg" />
              </>
            )}
          </Carousel>
        ) : (
          <div className="w-full h-full bg-gray-100 flex items-center justify-center">
            <Settings className="w-16 h-16 text-gray-400" />
          </div>
        )}

        {service.is_active && (
          <div className="absolute top-3 left-3 bg-green-500 text-white px-3 py-1 rounded-full text-xs font-medium">
            Active
          </div>
        )}
      </div> */}

      <div className="relative h-56 overflow-hidden">
        {allImages.length > 0 ? (
          <Carousel
            className="w-full h-full"
            opts={{
              align: "start",
              loop: true,
            }}
          >
            <CarouselContent>
              {allImages.map((imageUrl: string, index: number) => (
                <CarouselItem key={index} className="basis-full">
                  <div className="relative h-56 w-full">
                    <Image
                      src={imageUrl}
                      alt={`${service.name} - ${index + 1}`}
                      fill
                      className="object-cover transition-transform duration-500 hover:scale-110"
                    />
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>

            {allImages.length > 1 && (
              <>
                <CarouselPrevious className="left-3" />
                <CarouselNext className="right-3" />
              </>
            )}
          </Carousel>
        ) : (
          <div className="w-full h-full bg-gray-100 flex items-center justify-center">
            <Settings className="w-16 h-16 text-gray-400" />
          </div>
        )}

        {service.is_active && (
          <div className="absolute top-3 left-3 z-10 bg-green-500 text-white px-3 py-1 rounded-full text-xs">
            Active
          </div>
        )}
      </div>

      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-900 mb-1 line-clamp-1">{service.name}</h3>

        <p className="text-sm text-gray-600 mb-4 line-clamp-3 leading-relaxed">
          {service.description || 'No description available for this service.'}
        </p>

        {/* {service.media && service.media.images.length > 0 && (
          <div className="mb-4">
            <div className="text-xs font-medium text-gray-500 mb-2">Gallery</div>
            <div className="flex -space-x-1">
              {service.media.images.slice(0, 4).map((url: string, idx: number) => (
                <img
                  key={idx}
                  src={url}
                  alt={`Gallery ${idx + 1}`}
                  className="w-8 h-8 rounded-full border-2 border-white object-cover"
                />
              ))}
              {service.media.images > 4 && (
                <div className="w-8 h-8 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-600">
                  +{service.media.images.length - 4}
                </div>
              )}
            </div>
          </div>
        )} */}

        <div className="flex items-center justify-between pt-4 border-t border-gray-200">
          <div>
            <span className="text-sm text-gray-500">{service.category}</span>
          </div>
          <Link href={`/services/${service.slug}`}>
            <Button>
              View Details
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
